<template>
  <div class="mobile_contentBox">
    <div class="contentStitle">Video Media</div>
    <div class="contentTitle">视频媒体</div>
    <div class="video">
      <img :src="src.qyfw" alt srcset />
      <div class="mobile_yjh_item">
        <div class="mobile_yjh_item_text">
          <div class="text_line"></div>
          <div class="text_title">深圳市云久鸿劳务派遣有限公司简介！</div>
        </div>
        <div class="mobile_yjh_item_content">
          云久鸿于2010年5月在深圳市龙华区成立，总部位于深圳市龙华区福城街道新和社区观澜大道111号101富嘉商务中心，是一家专业的人力资源平台。云久鸿始终秉持着诚信、责任、共赢、感恩的企业价值观，以用心服务，筑就行业新高度为使命，为打造值得全球信赖的就业服务平台而不懈努力。
        </div>
      </div>
      <div class="videoItem">
        <div
          class="item"
          v-for="item in videoList"
          :key="item.id"
          @click="toDetail(item.id)"
        >
          <video
            width="400"
            height="200"
            controls
            :src="item.video_url"
            :poster="item.cover_image"
          ></video>
          <div class="itemTitle">{{ item.title }}</div>
          <div class="itemStitle">{{ item.sub_title }}</div>
        </div>
        <div class="item1"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import src from "../../../utils/assets";
export default {
  data() {
    return {
      src: src,
      form: {
        type: 1,
        category_id: 0,
        page: 1,
        limit: 15,
      },
      pageSize: 15,
      current: 1,
      total: 0,
      pageSizeOptions: ["15", "25", "50", "100"],
      videoList: [],
    };
  },
  created() {
    this.getNewsList();
    // this.getNewsType();
  },
  methods: {
    toDetail(id) {
      this.$router.push({
        path: "/newsMobileDetails",
        query: {
          id: id,
        },
      });
    },
    getNewsList() {
      const _this = this;
      axios
        .get(process.env.VUE_APP_URL + "/api/news/index", { params: _this.form })
        .then(function (res) {
          console.log(res);
          if (res.data.code == 0) {
            _this.videoList = res.data.data.data;
            _this.total = res.data.data.total;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.video {
  width: 330px;
  margin: 0 auto;
  img {
    width: 80%;
    margin: 10px auto;
  }
  .mobile_yjh_item {
    padding: 0;
  }
  .videoItem {
    margin: 10px auto;
    // height: 200px;
    .item {
      float: left;
      margin-right: 6px;

      .itemTitle {
        font-size: 14px;
        font-weight: 700;
        padding: 5px 0;
        border: 1px solid #da261d;
        border-top: none;
        border-bottom: none;
      }
      .itemStitle {
        line-height: 14px;
        border: 1px solid #da261d;
        border-top: none;
      }
    }
    .item:nth-child(2n) {
      margin-right: 0;
    }
    .item1 {
      clear: both;
    }
  }
}
</style>
